import { useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useSplitTransaction } from "../../../hooks/queries/useTransactionQueries";
import { toastService } from "../../../providers";
import { SPLIT_FORM_INITIAL_VALUES } from "../utils/transactionValidators";

export const useSplitTransactionModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [transaction, setTransaction] = useState(null);

  const { control, handleSubmit: rhfHandleSubmit, reset } = useForm({
    defaultValues: SPLIT_FORM_INITIAL_VALUES,
    mode: "onTouched",
  });

  const { mutate: splitMutate, isPending: isSubmitting } =
    useSplitTransaction();

  const openModal = useCallback(
    (row) => {
      if (!row || Object.keys(row).length === 0) {
        toastService.error("Cannot open split modal: invalid transaction data.");
        return;
      }

      setTransaction(row);
      reset(SPLIT_FORM_INITIAL_VALUES);
      setIsOpen(true);
    },
    [reset],
  );

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setTransaction(null);
    reset(SPLIT_FORM_INITIAL_VALUES);
  }, [reset]);

  const onSubmit = useCallback(
    (values) => {
      if (!transaction) return;

      const transactionId = transaction.transactionId || "";

      splitMutate(
        {
          transactionId,
          channels: [
            { amount: Number(values.amount), channel: values.channel },
          ],
        },
        {
          onSuccess: () => {
            toastService.success("Transaction split successfully.");
            closeModal();
          },
          onError: (_err) => {
            toastService.error("Failed to split transaction.");
          },
        },
      );
    },
    [splitMutate, transaction, closeModal],
  );

  return {
    isOpen,
    transaction,
    control,
    handleSubmit: rhfHandleSubmit(onSubmit),
    openModal,
    closeModal,
    isSubmitting,
  };
};

export default useSplitTransactionModal;
